import {SITE_CONFIG} from '../config';
import {getFavorites,readSaveStorage,writeSaveStorage} from './propertySaveStorage';

const KEY=`propertyCollections_${SITE_CONFIG.SITE_ID}`;
export function getPropertyCollections(){
  const rows=readSaveStorage(KEY,[]);
  if(!Array.isArray(rows))return [];
  const saved=getFavorites(),ids=new Set();
  return rows.filter(row=>row&&typeof row.id==='string'&&typeof row.name==='string'&&row.name.trim()&&Array.isArray(row.listingKeys)&&!ids.has(row.id)&&ids.add(row.id))
    .map(row=>({id:row.id,name:row.name.trim().slice(0,80),listingKeys:[...new Set(row.listingKeys.filter(key=>typeof key==='string'&&saved.has(key)))]}));
}
function validName(name,rows,except){
  const value=String(name||'').trim();
  if(!value)throw Error('Give your list a name.');
  if(value.length>80)throw Error('Use a name with 80 characters or fewer.');
  if(rows.some(row=>row.id!==except&&row.name.toLowerCase()===value.toLowerCase()))throw Error('You already have a list with that name.');
  return value;
}
export function createPropertyCollection(name){
  const rows=getPropertyCollections();
  const row={id:window.crypto?.randomUUID?.()||`list-${Date.now()}-${Math.random().toString(36).slice(2)}`,name:validName(name,rows),listingKeys:[]};
  writeSaveStorage(KEY,[...rows,row]);return row;
}
export function renamePropertyCollection(id,name){
  const rows=getPropertyCollections();if(!rows.some(row=>row.id===id))throw Error('This list is no longer available.');
  const value=validName(name,rows,id);writeSaveStorage(KEY,rows.map(row=>row.id===id?{...row,name:value}:row));
}
export function deletePropertyCollection(id){writeSaveStorage(KEY,getPropertyCollections().filter(row=>row.id!==id));}
export function setCollectionProperty(id,key,included){
  const listingKey=String(key);if(included&&!getFavorites().has(listingKey))throw Error('Save this home before adding it to a list.');
  const rows=getPropertyCollections();if(!rows.some(row=>row.id===id))throw Error('This list is no longer available.');
  writeSaveStorage(KEY,rows.map(row=>row.id!==id?row:{...row,listingKeys:included?[...new Set([...row.listingKeys,listingKey])]:row.listingKeys.filter(k=>k!==listingKey)}));
}
